import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    key: 0,
    title: "localhost개발환경에서만 보입니다."
};
const _hoisted_2 = {
    key: 1,
    title: "localhost개발환경에서만 보입니다."
};
const _hoisted_3 = { class: "header-title-text pr-3" };
const _hoisted_4 = { class: "order-info-item-wrapper grey lighten-5" };
const _hoisted_5 = { class: "mr-4" };
const _hoisted_6 = { class: "d-inline-flex" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_OrderStatusChip = _resolveComponent("OrderStatusChip");
    const _component_Chip = _resolveComponent("Chip");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_OrderDetailTimelineContent = _resolveComponent("OrderDetailTimelineContent");
    const _component_OrderInfoGridItem = _resolveComponent("OrderInfoGridItem");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_OrderCustomerSupportDialog = _resolveComponent("OrderCustomerSupportDialog");
    const _component_OrderCancelAllocatedDialog = _resolveComponent("OrderCancelAllocatedDialog");
    const _component_OrderCancelDialog = _resolveComponent("OrderCancelDialog");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_LoadingMask = _resolveComponent("LoadingMask");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.isOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isOpen) = $event)),
        "data-cy": "dialog-order-info",
        "content-class": "order-info-dialog",
        width: "1405",
        scrollable: "",
        "onClick:outside": _ctx.handleClickCloseBtn
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "card" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        variant: "text",
                        class: "btn-close",
                        onClick: _ctx.handleClickCloseBtn
                    }, null, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_v_card_title, {
                        class: "modal__head",
                        title: _ctx.isOpenModalOrderInfo
                    }, {
                        default: _withCtx(() => [
                            (_ctx.debugIsLocalhost && _ctx.order?.isAddressBaseOrder())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (주) "))
                                : _createCommentVNode("v-if", true),
                            (_ctx.debugIsLocalhost && _ctx.order?.isB2B())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (B) "))
                                : _createCommentVNode("v-if", true),
                            _createVNode(_component_v_icon, { class: "mr-2 brg-color-red-700" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-food ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('views.map_control.modal_order_info.title')), 1 /* TEXT */),
                            _createCommentVNode(" 주문 상태 칩 "),
                            _createVNode(_component_OrderStatusChip, { "status-code": _ctx.chipStatusCode }, null, 8 /* PROPS */, ["status-code"]),
                            _createCommentVNode(" 주소기반배달 칩 "),
                            (_ctx.order?.orderAgencyOptions?.allocateLimit === 1)
                                ? (_openBlock(), _createBlock(_component_Chip, {
                                    key: 2,
                                    class: "ml-2",
                                    "brg-chip-color": _ctx.AgencyOrderColor,
                                    text: _ctx.AgencyOrderText
                                }, null, 8 /* PROPS */, ["brg-chip-color", "text"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title"]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "pa-0" }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 배달 이력 "),
                            _createVNode(_component_OrderDetailTimelineContent, { order: _ctx.order }, null, 8 /* PROPS */, ["order"]),
                            _createCommentVNode(" 메인 영역 그리드 "),
                            _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderCardComponents, ({ componentName, title }, key) => {
                                    return (_openBlock(), _createBlock(_component_OrderInfoGridItem, {
                                        key: key,
                                        title: title
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(componentName), _mergeProps({ ref_for: true }, _ctx.dynamicComponentData[componentName], { order: _ctx.order }), null, 16 /* FULL_PROPS */, ["order"]))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    (!_ctx.isHQ)
                        ? (_openBlock(), _createBlock(_component_v_card_actions, {
                            key: 0,
                            class: "pa-4 d-flex justify-space-between align-center grey lighten-5"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createCommentVNode(" 본사상담 "),
                                    _createVNode(_component_OrderCustomerSupportDialog)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createCommentVNode(" 배차 취소 "),
                                    _createVNode(_component_OrderCancelAllocatedDialog),
                                    _createCommentVNode(" 주문 취소 "),
                                    _createVNode(_component_OrderCancelDialog, { disabled: _ctx.isDisabled }, null, 8 /* PROPS */, ["disabled"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true),
                    _createVNode(_component_LoadingMask, { "is-fetching": _ctx.isFetching }, null, 8 /* PROPS */, ["is-fetching"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside"]));
}
